import styled, { css } from 'styled-components'

type CardProps = {
  backgroundColor?: string
  backdropFilter?: string
}

export const Card = styled.article<CardProps>`
  background-color: ${(props) =>
    props.backgroundColor || `${props.theme.colors.black}4d`};

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 32px;
  gap: 24px;
  padding: 24px;

  width: 100%;

  ${(props) =>
    props.backdropFilter &&
    css`
      backdrop-filter: ${props.backdropFilter};
      -webkit-backdrop-filter: ${props.backdropFilter};
    `}
`
